'use client';

import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { CustomCursor } from '@/components/cursor/CustomCursor';
import { CursorProvider } from '@/components/cursor/CursorContext';
import { SmoothScrollProvider } from '@/components/animations/SmoothScrollProvider';

import { GlobalBackground } from '@/components/layout/GlobalBackground';
import { AmbientWow } from '@/components/effects/AmbientWow';
import WebWidgetScript from '@/components/WebWidget';

export default function MainLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <CursorProvider>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[10000] focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-black focus:shadow-lg focus:outline-2 focus:outline-offset-2 focus:outline-[#7CFFB2]"
      >
        Skip to main content
      </a>
      <CustomCursor />
      <GlobalBackground />
      <AmbientWow />
      <Header />
      <SmoothScrollProvider>
        <main id="main" className="min-h-screen">
          {children}
        </main>
        <Footer />
      </SmoothScrollProvider>
      <WebWidgetScript />
    </CursorProvider>
  );
}
